import { adminActionTypes } from "src/action_types/section_action_types";

export function selectWoundAlertRulesTablePageLimitAction(limit) {
  return {
    type: adminActionTypes.selectWoundAlertRulesTablePageLimit,
    payload: limit
  };
}
